/**
 * Card component from Bitcoin.com React CL
 * Reference: https://github.com/Bert-Bitcoin/Bitcoin.com-React-CL
 * AI Guide: https://github.com/Bert-Bitcoin/Bitcoin.com-React-CL/blob/main/AI_CONSUMPTION_GUIDE.md
 * 
 * IMPORTANT: The Card from React CL comes with sub-components accessible via Card.Header, Card.Content, etc.
 */

// Import directly from source since package is installed from GitHub without build
import { Card as ReactCLCard } from '@bitcoin-com/react-components/src/components/card'

// Re-export the Card component (which includes all sub-components)
export const Card = ReactCLCard

// Export sub-components separately for backward compatibility
export const CardHeader = ReactCLCard.Header
export const CardTitle = ReactCLCard.Title
export const CardDescription = ReactCLCard.Description
export const CardContent = ReactCLCard.Content
export const CardFooter = ReactCLCard.Footer
export const CardMedia = ReactCLCard.Media
export const CardAmount = ReactCLCard.Amount
export const CardIcon = ReactCLCard.Icon
export const CardDivider = ReactCLCard.Divider

// Re-export types
export type { CardProps } from '@bitcoin-com/react-components/src/components/card'
